import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import { HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  /** Region: Variable Declaration */
  private readonly API_URL: string = environment.apiUrl;
  private readonly CLIENT_ID: string = environment.clientId;
  private readonly GRANT_TYPE: string = environment.grantType;
  /** End Region */

  /** Region: Constructor */
  constructor(private http: HttpClient) { }
  /** EndRegion */

  get(url: string, requestParamModel?: any) {
    const fullURL = this.getURL(url, requestParamModel);
    const headers = this.getHeaders();
    return this.http.get(fullURL, {
      headers: headers,
      observe: 'response'
    });
  }

  /**
   *
   */
  getDownloadFileContent(url: string,) {
    const fullURL = this.API_URL + this.getURL(url);
    return fullURL;
  }

  /**
   * @description This method is used for the prepare the endpoint
   * @param url
   * @param requestParamModel
   * @private
   */
  private getURL(url: string, requestParamModel?: any): string {
    let newURL: string = url;
    if (requestParamModel) {
      newURL += requestParamModel.getParams();
    }
    return newURL;
  }

  /**
   * @description Builds the standard JSON headers. Authentication now travels in the HttpOnly
   * auth cookie (attached by httpInterceptor via withCredentials), so no Authorization header is
   * set here.
   * @private
   */
  private getHeaders(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('accept', 'application/json');
    headers = headers.append('Content-Type', 'application/json');
    return headers;
  }

  post(url: string, bodyModel: any) {
    const fullURL = this.getURL(url);
    const headers = this.getHeaders();
    return this.http.post(fullURL, bodyModel, {
      headers: headers
    });
  }

  uploadPost(url: string, bodyModel: any) {
    const fullURL = this.getURL(url);
    // No manual Content-Type / Authorization: the auth cookie is sent automatically.
    return this.http.post(fullURL, bodyModel);
  }

}
